import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import api from '../../utils/api';
import { toast } from 'react-toastify';

export const getLevel3Thunk = createAsyncThunk(
  'level3/getLevel3',
  async (config, { rejectWithValue }) => {
    try {
      const response = await api.getAllLevel3(config);

      return response.data;
    } catch (error) {
      console.log(error);


    }
  }
);


export const deleteLevel3Thunk = createAsyncThunk(
  'level3/deleteLevel3',
  async (id, { rejectWithValue, dispatch }) => {
    try {

      const response = await api.deleteCategory(id);
      dispatch(setLevel3Refresh())
      toast.success(response.data?.data?.message || 'Data deleted successfully')
      return response.data?.data;

    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message || "something went wrong")
    }
  }
);


export const updateLevel3category = createAsyncThunk(
  'level3/updateLevel3category',
  async (level3data, { rejectWithValue }) => {
    try {
      const { data, status } = await api.updatesubCategory(level3data);
      toast.success(data?.data?.message)
      return status
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message || 'something went wrong')

      return rejectWithValue(error.response.data);
    }
  }
);



export const exportLevel3Thunk = createAsyncThunk(
  'level3/exportLevel3Thunk',
  async (config, { rejectWithValue }) => {
    try {
      const response = await api.exportLevel3(config);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const deletemultiplelevel3CategoriesThunk = createAsyncThunk(
  'categories/deletemultiplelevel3CategoriesThunk',
  async (id, { rejectWithValue, dispatch }) => {
    try {

      const response = await api.deletemultipleCategory(id);
      dispatch(setLevel3Refresh())
      dispatch(setSelectedlevel3ids([]))
      dispatch(setSelectAlllvel3Cat(false))
      toast.success(response.data?.data?.message || 'Data deleted successfully')
      return response.data?.data;

    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message || "something went wrong")
    }
  }
);

// Slice for categories
const level3Slice = createSlice({
  name: 'level3',
  initialState: {
    level3: [],
    editLevel3: null,
    loading: false,
    error: null,
    refresh: false,
    exportLoading: false,
    exportedLevel3:[],
    page: 1,
    search: '',
    selectedIds:[],
    selectAll:false
  },
  reducers: {
    setLevel3Refresh: (state, action) => {
      state.refresh = !state.refresh
    },
    setLevel3category: (state, action) => {
      state.editLevel3 = action.payload;
    },
    setLevel3SubcategoryPage: (state, action) => {
      state.page = action.payload
    },
    setSearchLevel3: (state, action) => {
      state.search = action.payload
    },
    setSelectedlevel3ids:(state,action)=>{
      state.selectedIds = action.payload
    },
    setSelectAlllvel3Cat:(state,action) =>{
      state.selectAll = action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getLevel3Thunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getLevel3Thunk.fulfilled, (state, action) => {
        state.loading = false;
        state.level3 = action.payload;
      })
      .addCase(getLevel3Thunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      //delete
      .addCase(deleteLevel3Thunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteLevel3Thunk.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteLevel3Thunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      //update
      .addCase(updateLevel3category.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateLevel3category.fulfilled, (state, action) => {
        state.loading = false;
        state.editLevel3 = null; // Clear editCategory after update
      })
      .addCase(updateLevel3category.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      //export category
      .addCase(exportLevel3Thunk.pending, (state) => {
        state.exportLoading = true;
      })
      .addCase(exportLevel3Thunk.fulfilled, (state, action) => {
        state.exportLoading = false;
        state.exportedLevel3 = action.payload
      })
      .addCase(exportLevel3Thunk.rejected, (state, action) => {
        state.exportLoading = false;
      })
  },
});

export const { setLevel3Refresh, setLevel3category, setLevel3SubcategoryPage ,setSearchLevel3,setSelectedlevel3ids,setSelectAlllvel3Cat} = level3Slice.actions

export default level3Slice.reducer;

